import { Link } from 'react-router-dom';
import { IconChevronRight, IconClipboardList, IconClock, IconLock, IconMapPin } from '@tabler/icons-react';
import { PROCEDURES_VISIBILITY, type ProcedureDirectoryItem } from '@actschurch/ccms-sdk';
import { StatusPill } from '@/components/ui';
import { plural } from '@/lib/format';

/** One procedure in the directory: thumbnail, title, where it is, how long, how many steps. */
export function ProcedureCard({ item }: { item: ProcedureDirectoryItem }) {
  const isPrivate = item.visibilityID === PROCEDURES_VISIBILITY.Private;
  return (
    <Link to={`/p/${encodeURIComponent(item.code)}`} className="proc-pcard">
      <span className="thumb" aria-hidden="true">
        {item.coverThumbUrl ? <img src={item.coverThumbUrl} alt="" loading="lazy" decoding="async" /> : <IconClipboardList size={28} />}
      </span>
      <span className="txt">
        <span className="t">{item.title}</span>
        {item.categoryPath && <span className="cat">{item.categoryPath}</span>}
        <span className="meta">
          {item.locationName && <span><IconMapPin size={15} aria-hidden="true" /> {item.locationName}</span>}
          {item.estimatedMinutes ? <span><IconClock size={15} aria-hidden="true" /> {item.estimatedMinutes} min</span> : null}
          <span>{plural(item.stepCount, 'step')}</span>
        </span>
        {(item.isAssigned || isPrivate) && (
          <span className="pills">
            {item.isAssigned && <StatusPill tone="ok">Shared with you</StatusPill>}
            {isPrivate && !item.isAssigned && (
              <StatusPill tone="neutral" dot={false}><IconLock size={14} aria-hidden="true" /> Team only</StatusPill>
            )}
          </span>
        )}
      </span>
      <span className="chev" aria-hidden="true"><IconChevronRight size={22} /></span>
    </Link>
  );
}
